import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { Filter } from '@df/catalog-ui/listing/filter/filter';
import { FilterAttributeOption } from '@df/catalog-ui/listing/filter/filter-attribute-option';
import { ProductListing } from '@df/catalog-ui/listing/product-listing';
import { IProductDataV2 } from '@df/catalog/product/product';
import { Client } from '@df/core/service/client';
import { DfUiModule } from '@df/ui/df-ui.module';
import { DfModalService } from '@df/ui/modal/df-modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { Subscription } from 'rxjs';
import { StickyFreeComponent } from '../../common/sticky-free/sticky-free.component';
import { Product } from '../product/product.decorator';
import { NProductListingFiltersModal } from './product-listing-filters.modal.component';
import { ListingSortComponent } from './sort/listing-sort.component';

const CHIPS_FILTER_NUMBER = 4;

@Component({
    selector: 'product-listing-tools',
    templateUrl: 'product-listing-tools.html',
    styleUrl: 'product-listing-tools.scss',
    imports: [TranslationModule, StickyFreeComponent, ListingSortComponent, DfUiModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductListingToolsComponent implements OnChanges, OnDestroy {
    /**
     * Component subscriptions
     */
    private subscription?: Subscription;

    /**
     * Listing instnace
     */
    @Input()
    listing?: ProductListing<Product<IProductDataV2>>;

    /**
     * Dependencies
     */
    constructor(
        readonly client: Client,
        private dfModalService: DfModalService,
        private changeDetectorRef: ChangeDetectorRef
    ) {}

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['listing'] && changes['listing'].currentValue) {
            this.subscription?.unsubscribe();
            this.subscription = this.listing?.subscribe(() => this.changeDetectorRef.detectChanges());
        }
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }

    showFiltersModal(filter?: Filter<Product>) {
        if (this.listing) {
            const data: NProductListingFiltersModal.IModalData = {
                listing: this.listing,
                defaultFilter: filter
            };

            this.dfModalService.open(undefined, NProductListingFiltersModal.id, undefined, data);
        }
    }

    getFiltersForChips() {
        return this.listing?.getFiltersWithMatches().slice(0, CHIPS_FILTER_NUMBER);
    }

    protected getSelectedOptionsCount(filter: Filter<Product>): number {
        const filterType = filter.filterType;
        if (filterType === 'attribute-option' || filterType === 'stock') {
            return (<FilterAttributeOption<Product>>filter).selectedValues.length;
        }
        return 0;
    }
}
